export default __webpack_public_path__ + "static/media/Guia_acceso2024.96cf1c6c.pdf";